// Standardizes JSON ajax requests
// We must define the contentType and JSON.stringify the data or else null will be saved as an empty_string("") instead of nil
(function () {
  "use strict";

  function putJSON(url, data) {
    return ajaxJSON(url, data, "put");
  }

  function postJSON(url, data) {
    return ajaxJSON(url, data, "post");
  }

  function ajaxJSON(url, data, method) {
    return jQuery.ajax({
      url: url,
      method: method,
      contentType: "application/json",
      data: JSON.stringify(data),
    });
  }

  Sparkle.PageBuilder.Persistence = {
    putJSON: putJSON,
    postJSON: postJSON,
  };
})();
